import { getUser } from "Redux/Query";
import { higherCaseToCamelCase } from "ClientService";

export const getAccessGrant = (state, grant) => {
    const user = getUser(state);
    if(user.hasOwnProperty('accessGrants')) {
        return user[higherCaseToCamelCase(grant)] || false;
    }
    return false;
}